import { IComponentTree } from "../../../Global/Base/Rights/IComponentTree";
import { ComponentType } from "./ComponentTree";
import { ILogicalComponent } from "./ILogicalComponent";

export type ComponentTreeType = IComponentTree<ILogicalComponent, ComponentType>;
